/**
 * Smoothly scrolls to and focuses the target of any same-page anchor link
 * (an <a href="#some-id"> pointing to an element that actually exists on
 * the page). Used for links like the newsletter prompt on product pages
 * that point to a section further down the page (e.g. the footer signup
 * form). Rich-text settings in the theme editor strip class/data/onclick
 * attributes from links, so this matches on href alone.
 */
document.addEventListener('click', function (event) {
	var link = event.target.closest('a[href^="#"]');
	if (!link) return;

	var id = (link.getAttribute('href') || '').replace(/^#/, '');
	if (!id) return;

	var target = document.getElementById(id);
	if (!target) return;

	event.preventDefault();

	target.scrollIntoView({ behavior: 'smooth', block: 'center' });

	if (typeof target.focus === 'function') {
		var hadTabindex = target.hasAttribute('tabindex');
		if (!hadTabindex) target.setAttribute('tabindex', '-1');
		target.focus({ preventScroll: true });
	}
});
